export function Template({
  template,
  conf
}) {
  switch (template) {
    default:
      return null;
  }
}